import { formatMoney } from "src/helper/functions";
import { Gift } from "src/types/api";

interface Props {
  item: Gift;
}

const HistoryDetails = ({ item }: Props) => {
  // Format key names for display (e.g., "created_at" -> "Created At")
  const formatKey = (key: string): string => {
    if (key === "currency_iso") return "Currency";
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Format value for display (handles null, undefined, and other types)
  const formatValue = (key: any, value: any): string => {
    if (key === "currency_iso") {
      return value.toUpperCase();
    }
    if (key === "amount") return formatMoney(value).toLocaleString();
    if (value === null || value === undefined) return "N/A";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (value instanceof Date) return value.toLocaleDateString();
    return String(value);
  };

  // Keys to exclude from display
  const excludedKeys = [
    "__typename",
    "event_id",
    // "fee",
    "total_amount",
    "wallet_id",
    "wish_list_item_id",
    "id",
    "narration",
  ];

  return (
    <div className="mx-auto max-w-2xl rounded-lg bg-white p-6 shadow-md">
      <h3 className="mb-6 text-xl font-bold text-gray-800">Gift Details</h3>
      <div className="space-y-3">
        {Object.entries(item)
          .filter(([key]) => !excludedKeys.includes(key))
          .map(([key, value], index) => (
            <div
              key={index}
              className="flex items-start justify-between rounded-md bg-gray-50 p-3 transition-colors hover:bg-gray-100"
            >
              <span className="w-1/3 text-sm font-bold capitalize text-gray-600">
                {formatKey(key)}
              </span>
              <span className="w-2/3 break-words text-right text-sm text-gray-900">
                {formatValue(key, value)}
              </span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default HistoryDetails;
